export class ManualQCReviewRequest{
    qcReviewsForNumberReadsMap: any;
    qcReviewsForMetricsMergedMap: any;
    labId: string;
    batchId: string
}